<template>
  <MultiLineButton :text="$t('shooting.buttons.sendBackDMS')" :loading="loadingReplayDMS" @click="replayDMS" />
</template>

<script>
import MultiLineButton from '@/components/buttons/MultiLineButton.vue'
export default {
  components: {
    MultiLineButton
  },
  name: 'ReplayDMSButton',
  props: {
    shootingId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loadingReplayDMS: false
    }
  },
  methods: {
    async replayDMS() {
      const shootingId = this.$route.params.shootingId
      this.loadingReplayDMS = true
      const res = await this.$store.dispatch('replayDMS', shootingId)

      if (res) {
        this.loadingReplayDMS = false
        this.$mam.shootingsReplayDms()
      }
    }
  }
}
</script>
<style scoped></style>
